var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{ref:"apexchart",attrs:{"type":"line","options":_vm.apexchart.options,"series":_vm.apexchart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }